import axios from "axios";
import LogRocket from 'logrocket';
import { sha256 } from "js-sha256";
import { rootUrl, ganBots, ganDeniedList } from "./config";
import * as EmailValidator from "email-validator";

function bindCustomerEvents() {
  $(".notification-list").on("click", function (evt) {
    notificationSeen(evt.currentTarget.id, this);
  });
  $(".bi-chevron-down").on("click", function (evt) {
    notificationReadmore(evt.currentTarget.id);
  });
  $("button[name='updateAccountInfo']").on("click", function (evt) {
    evt.stopPropagation();
    accountUpdateInfo(this);
  });
  $("button[name='updateAddr']").on("click", function (evt) {
    evt.stopPropagation();
    accountUpdateAddr(this);
  });
  $("button[name='removeAddr']").on("click", function (evt) {
    evt.stopPropagation();
    accountRemoveAddr(this);
  });
  $("button[name='set_default_addr']").on("click", function (evt) {
    evt.stopPropagation();
    accountSetDefaultAddr(this);
  });

  $("#account-container select[name='city']").on("change", function (evt) {
    fetchDistricts($(this).val(), this);
  });

  $("#account-container select[name='district']").on("change", function (evt) {
    fetchWards($(this).val(), this);
  });

  $("div.frm-secretkey .show-pass").on("click", function (evt) {
    evt.stopPropagation();
    $(this).hide();
    $("div.frm-secretkey .hide-pass").show();
    $("div.frm-secretkey input[name='secretkey']").attr("type", "password");
  });

  $("div.frm-secretkey .hide-pass").on("click", function (evt) {
    evt.stopPropagation();
    $(this).hide();
    $("div.frm-secretkey .show-pass").show();
    $("div.frm-secretkey input[name='secretkey']").attr("type", "text");
  });

  $("div.frm-re-secretkey .show-pass").on("click", function (evt) {
    evt.stopPropagation();
    $(this).hide();
    $("div.frm-re-secretkey .hide-pass").show();
    $("div.frm-re-secretkey input[name='retype_secretkey']").attr(
      "type",
      "password"
    );
  });

  $("div.frm-re-secretkey .hide-pass").on("click", function (evt) {
    evt.stopPropagation();
    $(this).hide();
    $("div.frm-re-secretkey .show-pass").show();
    $("div.frm-re-secretkey input[name='retype_secretkey']").attr("type", "text");
  });

  $("input[name='mobile_number']").on("change", function (evt) {
    clearErrorMsg();
  });

  $("input[name='lineman_code']").on("change", function (evt) {
    clearErrorMsg();
  });

  $("input[name='referer_code']").on("change", function (evt) {
    clearErrorMsg();
  });

  $("input[name='customer_type']").on("change", function (evt) {
    clearErrorMsg();
    let custType = $("input[name='customer_type']:checked").val();
    custType = isNaN(custType)?0:Number(custType);
    switch(custType){
      case 0: // Member
      case 1: // Affiliate
      case 2: // KCX/KCN
        $("div.form-floating.frm-referer-code").addClass("d-none");
        $("div.form-floating.frm-lineman-code").addClass("d-none");
      break;
    }
  });

  $("input[name='secretkey']").on("change", function (evt) {
    clearErrorMsg();
  });

  $(".sign-out").on("click", function (evt) {
    evt.stopPropagation();
    signOut(this);
  });

  $("button[name='btn_forgot_pwd']").on("click", function (evt) { 
    evt.stopPropagation();
    let atStep = $(this).attr("data-step");
    atStep = isNaN(atStep) ? 0 : Number(atStep);
    //console.log("Step: ", atStep);
    switch (Number(atStep)) {
      case 1:
        checkExistsAccountForgotPwd(this);
        break;
      case 2:
        sendForgotPwdLinkOrVerifyCode(this);
        break;
      case 3:
        verifyCodeForgotPwd(this);
        break;
      case 4:
        resetPwdForUser(this);
        break;
      }
  });

  function checkExistsAccountForgotPwd(ele) {
    let url = `/customer/checkaccount`;
    let mobileNumber=$("div.forgotpwd-frm input[name='phone_or_email']").val();
    let custType = 0;
    let checkResult = isVietnamesePhoneNumberOrEmail(mobileNumber);
    if (checkResult && checkResult.status) {
      axios({ url: url, method: "POST", data: { val: mobileNumber, customer_type: custType, type:  checkResult.type, isForgotPwd: true} })
        .then(function (res) {
          let result = res.data;
          if(result && result.status){
            if (result.canLogins.length == 1) {
              $(`div.forgotpwd-frm select[name='account_type'] option[value='${result.canLogins[0].customer_type}']`).removeAttr("disabled");
              $("div.forgotpwd-frm select[name='account_type']").val(result.canLogins[0].customer_type);
              $("div.forgotpwd-frm select[name='account_type']").closest("div.form-floating").removeClass("d-none");
              $(`div.forgotpwd-frm select[name='account_type'] option:disabled`).remove();
            } else if(result.canLogins.length > 1) {
              for(let i=0; i < result.canLogins.length; i++){
                $(`div.forgotpwd-frm select[name='account_type'] option[value='${result.canLogins[i].customer_type}']`).removeAttr("disabled");
              }
              $("div.forgotpwd-frm select[name='account_type']").val(result.canLogins[0].customer_type);
              $("div.forgotpwd-frm select[name='account_type']").closest("div.form-floating").removeClass("d-none");
              $(`div.forgotpwd-frm select[name='account_type'] option:disabled`).remove();
            }
            $("div.forgotpwd-frm input[name='phone_or_email']").attr("disabled", "disabled");
            if(result.btnText) $("div.forgotpwd-frm button[name='btn_forgot_pwd']").text(result.btnText);
            $("div.forgotpwd-frm button[name='btn_forgot_pwd']").attr("data-step", 2);
          }else {
            $(".error-pass").html(result.msgTxt);
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    } else {
      $(".error-pass").html("Số điện thoại/e-mail không đúng!");
    }
  }
  
  $("button[name='btn_reset_pwd']").on("click", function (evt) {
    evt.stopPropagation();
    resetPwd(this);
  });
  bindViewAffiliateOrders($("#orderListModal"));

  $("button[name='export_affiliate_orders']").on("click", function (evt) {
    evt.stopPropagation();
    exportOrders(this);
  });

  $("button[name='save_bank_account']").on("click", function (evt) {
    evt.stopPropagation();
    mergeBankAccount(this);
  });

  $("button[name='withdraw_register_btn']").on("click", function (evt) {
    evt.stopPropagation();
    withdrawRegister(this);
  });
  $("select[name='bank_id']").on("change", function (evt) {
    evt.stopPropagation();
    selectedBankId(this);
  });


  $("button[name='btn_signin_actions']").on("click", function (evt) {
    evt.stopPropagation();
    let atStep = $(this).attr("data-step");
    atStep = isNaN(atStep) ? 0 : Number(atStep);
    //console.log("Step: ", atStep);
    switch (Number(atStep)) {
      case 1:
        checkExistsAccount(this);
        break;
      case 2:
        verifyCode(this);
        break;
      case 3:
        signInUser(this);
        break;
    }
  });
  $("button[name='btn_signup_actions']").on("click", function (evt) {
    evt.stopPropagation();
    let atStep = $(this).attr("data-step");
    atStep = isNaN(atStep) ? 0 : Number(atStep);
    switch (Number(atStep)) {
      case 1:
        registerPhoneNumber(this);
        $("input[name='mobile_number']").focus();
        break;
      case 2:
        verifyCode(this);
        break;
      case 3:
        signUpUser(this);
        break;
    }
  });
  $("button[name='register_link_copy']").on("click", function (evt) {
    evt.stopPropagation();
    var copyText = document.getElementById("refreral_link");
    copyText.select();
    copyText.setSelectionRange(0, 99999); // For mobile devices
    navigator.clipboard.writeText(copyText.value);
    $(this).find("i.bi").removeClass("bi-clipboard").addClass("bi-clipboard-check");
  });
}

function resendBindEvents() {
  $("button[name='btn_resend']").on("click", function (evt) {
    evt.stopPropagation();
    let mobileNumber = $("input[name='mobile_number']").val();
    let token = $("input[name='captcha-token']").val();
    axios({
      url: "/customer/send-sms",
      method: "POST",
      data: { phone: mobileNumber, captchaToken: token },
    })
      .then(function (res) {
        console.log("res", res);
        $("input[name='session-info']").val(res.data.sessionInfo);
        $("input[name='code']").focus();
        setCountDown(60);
      })
      .catch(function (err) {
        console.log(err);
      });
  });
}

$("#modal_EditAddress").on("show.bs.modal", (event) => {
  $("#modal_EditAddress input[name='addrId']").val("");
  $("#modal_EditAddress input[name='address']").val("");
  $("#modal_EditAddress input[name='phone_number']").val("");
  const addr_id = $(event.relatedTarget).data("addr-id");
  let url = `/customer/getAddr?code=${addr_id}`;
  axios({ url: url, method: "GET" })
    .then(function (res) {
      console.log(res.data);
      if (res.status && res.data) {
        let addr = res.data.addr;
        if (addr && addr.addrObj) {
          $("#modal_EditAddress input[name='addrId']").val(addr.ward);
          $("#modal_EditAddress input[name='address']").val(addr.address);
          $("#modal_EditAddress input[name='full_name']").val(addr.full_name);
          $("#modal_EditAddress input[name='phone_number']").val(addr.phone_number);
          let addObj = addr.addrObj;
          if (addObj.parent && addObj.parent.parent_code) {
            $("#modal_EditAddress select[name='city']").val(
              addObj.parent.parent_code
            );
            fetchDistricts(
              addObj.parent.parent_code,
              $("#account-container select[name='district']"),
              addObj.parent.code
            );
          }
          if (addObj.parent && addObj.parent.code) {
            $("#modal_EditAddress select[name='city']").val(
              addObj.parent.parent_code
            );
            fetchWards(
              addObj.parent.code,
              $("#account-container select[name='ward']"),
              addObj.code
            );
          }
        }
      }
    })
    .catch(function (err) {
      console.log(err);
    });
});

function isValidForRegistration() {
  let mobileNumber = $("div.register-frm input[name='mobile_number']").val();
  let checkVal = isVietnamesePhoneNumberOrEmail(mobileNumber);
  if (checkVal && checkVal.status) {
    return true;
    let custType = $("div.register-frm input[name='customer_type']:checked").val();
    switch(Number(custType)){
      case 0: // Member
        return true;
      case 1: // Affiliate
        let referCode = $("div.frm-referer-code input[name='referer_code']").val();
        if(!referCode) {
          $("div.frm-referer-code .error-msg").text("Mã giới thiệu không đúng!");
          return false;
        }
        return true;
      case 2: // KCX
      let linemanCode = $("div.frm-lineman-code input[name='lineman_code']").val();
      if(!linemanCode) {
        $("div.frm-lineman-code .error-msg").text("Mã người quản lý không đúng!");
        return false;
      }
      return true;
    }
  }
  return false;
}

function isVietnamesePhoneNumberOrEmail(val) {
  if(/(0)(3|5|7|8|9)+([0-9]{8})\b/.test(val)) return {status: true, type: 'PhoneNumber'};
  if(EmailValidator.validate(val)) return {status: true, type: 'Email'};
  return {status: false, type: 'Unknown', data: val};
}

function registerPhoneNumber(ele) {
  let url = `/customer/checkregistered`;
  let mobileNumber = $("div.register-frm input[name='mobile_number']").val();
  let custType = $("div.register-frm input[name='customer_type']:checked").val();
  let checkVal = isVietnamesePhoneNumberOrEmail(mobileNumber);

  if (checkVal && checkVal.status && isValidForRegistration()) {
    let referCode = '';
    switch(Number(custType)){
      case 0: 
      case 1:
        referCode = $("div.frm-referer-code input[name='referer_code']").val();
        break;
      case 2: 
        referCode = $("div.frm-lineman-code input[name='lineman_code']").val();
        break;
      default: referCode = '';
    }
    if(!referCode) referCode = 'chily.com.vn';

    axios({
      url: url,
      method: "POST",
      data: { val: mobileNumber, customer_type: custType,type:checkVal.type,refCode: referCode}
    })
      .then(function (res) {
        if (res.data.status && (res.data.canRegister || res.data.needVerify)){
          $("input[name='session-info']").val(res.data.verifyToken);
          $("label#verifyCodeLabel").html(res.data.codeSentToMsg);
          $("input[name='code']").val("");
          waitingForCheckCode(ele,res.data);
        }
        else $("div.register-frm .error-phone").html(res.data.msgTxt);
      })
      .catch(function (err) {
        $("div.register-frm .error-phone").text(err.message);
      });
  } else {
    $("div.register-frm .error-phone").text("Thông tin đăng ký không đúng. Kiểm tra lại thông tin và chỉnh sửa cho đúng trước khi đăng ký!");
  }
}

function checkExistsAccount(ele) {
  let url = `/customer/checkaccount`;
  let mobileNumber=$("input[name='mobile_number']").val();
  let custType = $("select[name='login_as']").val();
  let checkResult = isVietnamesePhoneNumberOrEmail(mobileNumber);
  if (checkResult && checkResult.status) {
    axios({ url: url, method: "POST", data: { val: mobileNumber, customer_type: custType, type:  checkResult.type} })
      .then(function (res) {
        if (res.data.status && res.data.canLogins.length >= 1) {
          $("#secretkey").closest("div.form-floating").removeClass("d-none");
          $("button[name='btn_signin_actions']").attr("data-step", 3);
        } else {
          $(".error-phone").html(res.data.msgTxt);
          $("div.register-item").removeClass("d-none");
        }
      })
      .catch(function (err) {
        console.log(err);
      });
  } else {
    $(".error-phone").html("Số điện thoại/e-mail không đúng!");
  }
}

function clearErrorMsg() {
  $("div.resetpwd-frm .show-msg").text("");
  $("div.resetpwd-frm .error-pass.retype-pwd").text("");
  $("div.forgotpwd-frm .error-pass").text("");
  $("div.frm-secretkey .error-pass").text("");
  $("div.frm-verify-code span.error-msg").html("");
  $(".error-phone").text("");
  $("div.register-frm .error-phone").text("");
  $("div.frm-referer-code .error-msg").text("");
  $("div.frm-lineman-code .error-msg").text("");
}

function verifyCodeForgotPwd(ele) {
  let url = `/customer/verifycode`;
  let code = $("div.forgotpwd-frm input[name='code']").val();
  let sessionInfo = $("div.forgotpwd-frm input[name='session-info']").val();
  let mobile_number = $("div.forgotpwd-frm input[name='phone_or_email']").val();
  let isFor="ForgotPwd";
  let checkResult = isVietnamesePhoneNumberOrEmail(mobile_number);
  clearErrorMsg();
  if (checkResult && checkResult.status) {
    let type = checkResult.type;
    axios({ url: url, method: "POST", data: { code, sessionInfo, mobile_number, type, isFor } })
    .then(function (res) {
      //console.log(res.data.status);
      if (res.data.status) {
        $("#floatingCode").closest("div.form-floating").addClass("d-none");
        $("#secretkey").closest("div.form-floating").removeClass("d-none");
        $("#retype_secretkey").closest("div.form-floating").removeClass("d-none");
        $("button[name='btn_resend']").text(2);
        $("button[name='btn_resend']").attr("data-verified", "true");
        $(ele).text(res.data.btnText);
        $(ele).attr("data-step", 4);
      } else if(res.data.errMsg){
        $("div.frm-verify-code span.error-msg").html(res.data.errMsg);
      }
    })
    .catch(function (err) {
      $("div.frm-verify-code span.error-msg").html(err.message);
    });
  }
}

function verifyCode(ele) {
  let url = `/customer/verifycode`;
  let code = $("input[name='code']").val();
  let sessionInfo = $("input[name='session-info']").val();
  let mobile_number = $("input[name='mobile_number']").val();
  let isFor="Register";
  let checkResult = isVietnamesePhoneNumberOrEmail(mobile_number);
  if (checkResult && checkResult.status) {
    let type = checkResult.type;
    axios({ url: url, method: "POST", data: { code, sessionInfo, mobile_number, type, isFor } })
    .then(function (res) {
      //console.log(res.data.status);
      if (res.data.status) {
        $("#floatingCode").closest("div.form-floating").addClass("d-none");
        $("#secretkey").closest("div.form-floating").removeClass("d-none");
        $("#retype_secretkey").closest("div.form-floating").removeClass("d-none");
        $("button[name='btn_resend']").text(2);
        $("button[name='btn_resend']").attr("data-verified", "true");
        $(ele).attr("data-step", 3);
      } else if(res.data.errMsg){
        $("div.frm-verify-code span.error-msg").html(res.data.errMsg);
      }
    })
    .catch(function (err) {
      $("div.frm-verify-code span.error-msg").html(err.message);
    });
  }
}

function signInUser(ele) {
  let pass = sha256($("input[name='secretkey']").val());
  let mobileNumber = $("input[name='mobile_number']").val();
  let backUrl = $("input[name='backUrl']").val();
  let rememberMe = $("input[name='remember_me']").is(":checked");
  let customer_type = $("select[name='login_as']").val();
  let checkResult = isVietnamesePhoneNumberOrEmail(mobileNumber);
  axios({
    url: "/customer/login",
    method: "POST",
    data: {
      pwd: pass,
      val: mobileNumber,
      customer_type: customer_type,
      type: checkResult.type,
      rm: rememberMe,
      backUrl: backUrl
    },
  })
    .then(function (res) {
      if (res.data.status) {
        LogRocket.identify(`${res.data.customerInfo.id}`, {
          name: `${res.data.customerInfo.full_name}`,
          email: `${res.data.customerInfo.id}`
        });
        location.href = res.data.backUrl;
      } else {
        $("div.frm-secretkey .error-pass").text(res.data.errTxt);
      }
    })
    .catch(function (err) {
      console.log(err);
    });
}

function sendForgotPwdLinkOrVerifyCode(ele) {
  let phoneOrEmail = $("input[name='phone_or_email']").val();
  let checkResult = isVietnamesePhoneNumberOrEmail(phoneOrEmail);
  let account_type = $("div.forgotpwd-frm select[name='account_type']").val();
  $("div.forgotpwd-frm .error-pass").text("");
  axios({
    url: "/customer/forgotpwd",
    method: "POST",
    data: {
      val: phoneOrEmail,
      customer_type: account_type,
      type: checkResult.type
    }
  }).then(function (res) {
    let result=res.data;
    if(result.status){
      if(result.loginType == "PhoneNumber"){
        $("div.forgotpwd-frm select[name='account_type']").attr("disabled", "disabled");
        $("div.forgotpwd-frm input[name='session-info']").val(result.verifyToken);
        $("label#verifyCodeLabel").html(result.codeSentToMsg);
        $("input[name='code']").val("");
        $("div.forgotpwd-frm div.frm-verify-code").removeClass("d-none");
        waitingForCheckCode(ele,result);
        if(result.btnText) $("div.forgotpwd-frm button[name='btn_forgot_pwd']").text(result.btnText);
        $("div.forgotpwd-frm button[name='btn_forgot_pwd']").attr("data-step", 3);
      }else $("div.forgotpwd-frm .error-pass").text(result.errTxt);
    }else $("div.forgotpwd-frm .error-pass").text(result.errTxt);
  }).catch(function (err) {
    $("div.forgotpwd-frm .error-pass").text(err.message);
  });
}

function resetPwd(ele) {
  let phoneOrEmail = $("input[name='phone_or_email']").val();
  let checkResult = isVietnamesePhoneNumberOrEmail(phoneOrEmail);
  let account_type = $("input[name='account_type']").val();
  let pwd = sha256($("input[name='new_pwd']").val());
  let retypepwd = sha256($("input[name='retype_pwd']").val());

  if(pwd === retypepwd){
    axios({
      url: "/customer/resetpwd",
      method: "POST",
      data: {
        val: phoneOrEmail,
        customer_type: account_type,
        type: checkResult.type,
        pwd: pwd
      }
    }).then(function (res) {
      $("div.resetpwd-frm .show-msg").text(res.data.msgTxt);
      setTimeout(function() {
        window.location.href="/customer/login";
      }, 3000);
    }).catch(function (err) {
      $("div.resetpwd-frm .show-msg").text(err.message);
    });
  }else{
    $("div.resetpwd-frm .error-pass.retype-pwd").text("Mật khẩu không đúng giữa 2 lần nhập");
  }
}

function resetPwdForUser(ele) {
  let hashPwd = sha256($("div.forgotpwd-frm input[name='secretkey']").val());
  let hashPwdRetype = sha256($("div.forgotpwd-frm input[name='retype_secretkey']").val());
  let mobileNumber = $("div.forgotpwd-frm input[name='phone_or_email']").val();
  let custType = $("div.forgotpwd-frm select[name='account_type']").val();
  if(hashPwd === hashPwdRetype){
    let checkResult = isVietnamesePhoneNumberOrEmail(mobileNumber);
    axios({
      url: "/customer/resetpwd",
      method: "POST",
      data: {
        val: mobileNumber,
        customer_type: custType,
        type: checkResult.type,
        pwd: hashPwd
      }
    }).then(function (res) {
      $("div.forgotpwd-frm .error-phone").text(res.data.msgTxt);
      setTimeout(function() {
        window.location.href="/customer/login";
      }, 3000);
    }).catch(function (err) {
      $("div.forgotpwd-frm .error-phone").text(err.message);
    });
  }else{
    $("div.forgotpwd-frm .error-repass").text("Mật khẩu không đúng giữa 2 lần nhập");
  }
}

function signUpUser(ele) {
  let hashPwd = sha256($("div.register-frm input[name='secretkey']").val());
  let mobileNumber = $("div.register-frm input[name='mobile_number']").val();
  let custType = $("div.register-frm input[name='customer_type']:checked").val();
  let referer_code = $("div.frm-referer-code input[name='referer_code']").val();
  let lineman_code = $("div.frm-lineman-code input[name='lineman_code']").val();
  let checkResult = isVietnamesePhoneNumberOrEmail(mobileNumber);
  if(checkResult && checkResult.status){
    axios({
      url: "/customer/register",
      method: "POST",
      data: { pwd: hashPwd, val: mobileNumber, customer_type: custType, type: checkResult.type, referer_code: referer_code, lineman_code: lineman_code},
    }).then(async function (res) {
      if (res.data.status) {
        await sendWelcomeVoucher (res.data.customer.id, res.data.customer.referer);
        location.href = "/customer/login";
      }
    }).catch(function (err) {
      console.log(err);
    });
  }
}

function signOut(ele) {
  let url = ` /customer/logout`;
  axios({
    url: url,
    method: "POST"
  }).then(function (res) {
    location.href = `/customer/login`;
  }).catch(function (err) {
    console.log(err);
  });
}

function waitingForCheckCode(ele, data) {
  $("#floatingCode").closest("div.form-floating").removeClass("d-none");
  $(ele).attr("data-step", 2);
  setCountDown(60*Number(data.expire));
  $("input[name='code']").focus();
  $("input[name='mobile_number']").attr("disabled", true);
  $("input[name='customer_type']").attr("disabled", true);
}

function prepareForCheckingCode(ele) {
  axios({
    url: "https://identitytoolkit.googleapis.com/v1/recaptchaParams?key=AIzaSyD6At2v8wsEcdmgfb4s5yyLf-OuHTkzPBk",
    method: "GET",
  })
    .then(function (res) {
      //console.log("res", res);
      $("input[name='recaptcha_site_key']").val(res.data.recaptchaSiteKey);
      addScript(`https://www.google.com/recaptcha/enterprise.js?hl=vi`, () => {
        const sitekey = res.data.recaptchaSiteKey;
        const theme = "light";
        const size = "invisible";
        let readyInterval;
        let widget;
        let onCloseObserver;
        let onCloseInterval;

        const onClose = () => {
          //console.log("onClose");
        };

        const onLoad = () => {
          console.log("rnRecaptcha.onLoad");
          window.rnRecaptcha.execute();
        };

        const onExpire = () => {
          console.log("rnRecaptcha.onExpire");
        };

        const onError = (error) => {
          console.log("rnRecaptcha.onError", error);
        };

        const onVerify = (token) => {
          console.log("rnRecaptcha.onVerify - Token", token);
          $("input[name='captcha-token']").val(token);
          let mobileNumber = $("input[name='mobile_number']").val();
          let checkResult = isVietnamesePhoneNumberOrEmail(mobileNumber);
          if(checkResult && checkResult.status){
            axios({
              url: "/customer/sendverifycode",
              method: "POST",
              data: { val: mobileNumber, captchaToken: token,type: checkResult.type },
            })
              .then(function (res) {
                console.log("Response data", res.data);
                if (res.data.status && res.data.sessionInfo) {
                  $("input[name='session-info']").val(res.data.sessionInfo);
                  $("#floatingCode")
                    .closest("div.form-floating")
                    .removeClass("d-none");
                  $(ele).attr("data-step", 2);
                  setCountDown(60);
                  $("input[name='code']").focus();
                  $("input[name='mobile_number']").attr("disabled", true);
                }
              })
              .catch(function (err) {
                console.log(err);
              });
          }else console.log("checkResult: ",checkResult);
        };

        const isReady = () =>
          Boolean(
            typeof window === "object" &&
              window.grecaptcha &&
              window.grecaptcha.enterprise.render
          );

        const registerOnCloseListener = () => {
          if (onCloseObserver) {
            onCloseObserver.disconnect();
          }
        };

        const isRendered = () => {
          return typeof widget === "number";
        };

        const renderRecaptcha = () => {
          widget = window.grecaptcha.enterprise.render("recaptcha-container", {
            sitekey,
            size,
            theme,
            callback: onVerify,
            "expired-callback": onExpire,
            "error-callback": onError,
          });
          console.log("widget", widget);
          if (onLoad) {
            onLoad();
          }
          onCloseInterval = setInterval(registerOnCloseListener, 1000);
        };

        const updateReadyState = () => {
          if (isReady()) {
            console.log("updateReadyState isReady true");
            clearInterval(readyInterval);
            renderRecaptcha();
          }
        };

        if (isReady()) {
          console.log("isReady true");
          renderRecaptcha();
        } else {
          console.log("isReady false");
          readyInterval = setInterval(updateReadyState, 1000);
        }

        window.rnRecaptcha = {
          execute: () => {
            window.grecaptcha.enterprise.execute(widget);
          },
          reset: () => {
            console.log("reset");
            window.grecaptcha.enterprise.reset(widget);
          },
        };
      });
    })
    .catch(function (err) {
      console.log(err);
    });
}

function setCountDown(waitTime) {
  let isVerified = $("button[name='btn_resend']").attr("data-verified");
  let countDown = $("button[name='btn_resend']").text();
  countDown = isNaN(countDown) ? waitTime : Number(countDown);
  if (countDown > 1) {
    $("button[name='btn_resend']").text(`${countDown}`);
    setTimeout(() => {
      $("button[name='btn_resend']").text(countDown - 1);
      setCountDown();
    }, 1000);
  } else if (isVerified == "false") {
    $("button[name='btn_resend']").removeClass("disabled");
    $("button[name='btn_resend']").text(`Gửi lại mã xác nhận`);
    resendBindEvents();
  }
}

function addScript(src, callback) {
  var s = document.createElement("script");
  s.setAttribute("src", src);
  s.onload = callback;
  document.body.appendChild(s);
}

function fetchDistricts(city_code, ele, selVal) {
  let url = `${rootUrl}/address/districts?city_code=${city_code}`;
  freezeUI();
  axios({ url: url, method: "GET" })
    .then(function (res) {
      unFreezeUI();
      bindOptsToElement(
        res.data,
        $("#account-container select[name='district']"),
        selVal
      );
    })
    .catch(function (err) {
      console.log(err);
    });
}

function fetchWards(dt_code, ele, selVal) {
  let url = `${rootUrl}/address/wards?dt_code=${dt_code}`;
  freezeUI();
  axios({ url: url, method: "GET" })
    .then(function (res) {
      unFreezeUI();
      bindOptsToElement(
        res.data,
        $("#account-container select[name='ward']"),
        selVal
      );
    })
    .catch(function (err) {
      console.log(err);
    });
}
function bindOptsToElement(items, ele, selVal) {
  if (items && items.length) {
    $(ele).children("option:not(:first)").remove();
    $.each(items, function (key, value) {
      $(ele).append(
        $("<option></option>").attr("value", value.code).text(value.full_name)
      );
    });
    if (selVal) $(ele).val(selVal);
  }
}
function freezeUI() {
  $("div#account-container").LoadingOverlay("show", {
    image: "",
    text: "",
    background: "rgba(255,255,255,0.3)",
    zIndex: 1003,
    fade: false,
  });
}

function unFreezeUI() {
  $("div#account-container").LoadingOverlay("hide", true);
}

function acctPostUpd(cust) {
  $("span.account-full-name").html(cust.full_name);
  $("span.account-email").html(cust.email);
  $("span.account-mobile-number").html(cust.mobile_number);
}

function addrPostUpd(data) {
  if (data.html) {
    $("div.card.addr-box").remove();
    let $newAddr = $(data.html);
    $newAddr.insertBefore($("form[name='account_addrs']"));
    $newAddr.find("button[name='removeAddr']").on("click", function (evt) {
      evt.stopPropagation();
      accountRemoveAddr(this);
    });
    $newAddr.find("button[name='set_default_addr']").on("click", function (evt) {
      evt.stopPropagation();
      accountSetDefaultAddr(this);
    });
  }
}

function accountUpdateInfo(ele) {
  $("form[name='account_info']").validate({
    rules: {
      email: { required: true },
      full_name: { required: true },
      address: { required: true },
      city: { required: true },
      district: { required: true },
      ward: { required: true },
    },
    messages: {
      email: $("input[name='email']").data("errmsg"),
      full_name: $("input[name='full_name']").data("errmsg"),
      address: $("input[name='address']").data("errmsg"),
      city: $("select[name='city']").data("errmsg"),
      district: $("select[name='district']").data("errmsg"),
      ward: $("select[name='ward']").data("errmsg"),
    },
  });

  //if ($("form[name='account_info']").valid()) {
    const data = $("form[name='account_info']").serialize();
    let url = `${rootUrl}/customer/account`;
    freezeUI();
    axios({ url: url, method: "POST", data })
      .then(function (res) {
        unFreezeUI();
        if (res.data.status && res.data.updCustomer) {
          acctPostUpd(res.data.updCustomer);
        } else {
          $("div.error-account-upd").html(res.data.errorMsg);
        }
      })
      .catch(function (err) {
        console.log(err);
      });
  //}
}

function accountSetDefaultAddr(ele) {
  let url = `${rootUrl}/customer/defaultAddr`;
  let data = { addrId: $(ele).data("addr-id") };
  freezeUI();
  axios({ url: url, method: "POST", data })
    .then(function (res) {
      unFreezeUI();
      if (res.data.status) {
        addrPostUpd(res.data);
      } else {
        $("div.error-account-upd").html(res.data.errorMsg);
      }
    })
    .catch(function (err) {
      console.log(err);
    });
}

function accountRemoveAddr(ele) {
  let url = `${rootUrl}/customer/removeAddr`;
  let data = { code: $(ele).data("addr-id") };
  freezeUI();
  axios({ url: url, method: "POST", data })
    .then(function (res) {
      unFreezeUI();
      if (res.data.status) {
        $(ele).closest("div.card.addr-box").remove();
      } else {
        $("div.error-account-upd").html(res.data.errorMsg);
      }
    })
    .catch(function (err) {
      console.log(err);
    });
}

function bindViewAffiliateOrders(dlgEle){
  const orderListModal = document.getElementById('orderListModal');
  if(orderListModal){
    let url = `${rootUrl}/customer/viewAffiliateOrders`;
    orderListModal.addEventListener('show.bs.modal', event => {
      // Button that triggered the modal
      const button = event.relatedTarget;
      let data={};
      axios({ url: url, method: "POST", data }).then(function (res) {
        if (res.data.status) {
          // Update the modal's content.
          const modalTitle = orderListModal.querySelector('.modal-title')
          const modalBody = orderListModal.querySelector('.modal-body')
          modalTitle.textContent = ` ${res.data.msg}`;
          modalBody.innerHTML = res.data.htmlCode;
        } else {
        }
      })
      .catch(function (err) {
        console.log(err);
      });
    })
  }
}

function withdrawRegister(ele) {
  $("form[name='account_info']")[0].checkValidity();
  let amount=$("input[name='withdraw_amount']").val();
  let bank_id=$("select[name='bank_id']").val();
  if(amount && bank_id && !isNaN(amount) && Number(amount) >= 200000){
    let url = `${rootUrl}/customer/registerWithdraw`;
    let customer_id=$("input[name='customer_id']").val();
    let data = { amount: amount, bank_id:bank_id, customer_id:  customer_id};
    axios({ url: url, method: "POST", data })
      .then(function (res) {
        if (res.data.status) {
          $(".withdraw-register.alert.alert-info").html(res.data.msg);
          $(".withdraw-register.alert.alert-info").removeClass("hide");
        }
      })
      .catch(function (err) {
        $(".withdraw-register.alert.alert-info").html(err.message);
      });
  }else {
    $("#withdraw_form").addClass("was-validated");
  }
}

function selectedBankId(ele) {
    let url = `${rootUrl}/customer/getBankById`;
    let customer_id=$("input[name='customer_id']").val();
    let bank_id = $("select[name='bank_id']").val();
    let data = { bank_id:  bank_id, customer_id:  customer_id};

    axios({ url: url, method: "POST", data })
      .then(function (res) {
        if (res.data.status) {
          $("#bank_account_dlg input[name='edit_bank_id']").val(res.data.bankInfo.bank_id);
          $("#bank_account_dlg input[name='account_number']").val(res.data.bankInfo.account_number);
          $("#bank_account_dlg input[name='account_owner']").val(res.data.bankInfo.account_owner);
          $("#bank_account_dlg input[name='bank_brand_name']").val(res.data.bankInfo.bank_name);
        }
      })
      .catch(function (err) {
        console.log(err);
      });
}

function mergeBankAccount(ele) {
  $("form[name='account_info']")[0].checkValidity();
  let account_number=$("#bank_account_dlg input[name='account_number']").val();
  let account_owner=$("#bank_account_dlg input[name='account_owner']").val();
  let account_bank=$("#bank_account_dlg input[name='bank_brand_name']").val();
  let bank_id=$("#bank_account_dlg input[name='edit_bank_id']").val();
  if(account_number && account_owner && account_bank){
    let url = `${rootUrl}/customer/mergeBankAccount`;
    let customer_id=$("input[name='customer_id']").val();
    
    let data = { bank_id: bank_id, account_number: account_number, account_owner:account_owner, bank_name:  account_bank, customer_id:  customer_id};
    axios({ url: url, method: "POST", data })
      .then(function (res) {
        if (res.data.status) {
          let newBankData = res.data.newBank;
          if(newBankData){
            $("select[name='bank_id']").append($('<option>', {
              value: newBankData.bank_id,
              text: `${newBankData.account_owner} - ${newBankData.bank_name}`
            }));
            $("#bank_account_dlg input[name='edit_bank_id']").val(newBankData.bank_id);
            $("#bank_account_dlg .alert.alert-info").html(res.data.msg);
            $("#bank_account_dlg .alert.alert-info").removeClass("hide");
          }else{
            $("#bank_account_dlg .alert.alert-info").html(res.data.msg);
            $("#bank_account_dlg .alert.alert-info").removeClass("hide");
          }
        }
      })
      .catch(function (err) {
        console.log(err);
      });
  }else {
    $("#bank_account_dlg .modal-body").addClass("was-validated");
  }
}

function exportOrders(ele) {
  let url = `${rootUrl}/customer/expOrders`;
  let data = { exportTo: $(ele).data("data-export-folder") };
  axios({ url: url, method: "POST", data })
    .then(function (res) {
      if (res.data.status) {
        $("#dlgMsg").html(res.data.msg);
      }
    })
    .catch(function (err) {
      console.log(err);
    });
}

function accountUpdateAddr(ele) {
  $("form[name='account_addrs']").validate({
    rules: {
      address: { required: true },
      city: { required: true },
      district: { required: true },
      ward: { required: true },
    },
    messages: {
      address: $("input[name='address']").data("errmsg"),
      city: $("select[name='city']").data("errmsg"),
      district: $("select[name='district']").data("errmsg"),
      ward: $("select[name='ward']").data("errmsg"),
    },
  });

  if ($("form[name='account_addrs']").valid()) {
    const data = $("form[name='account_addrs']").serialize();
    let url = `${rootUrl}/customer/updateAddr`;
    freezeUI();
    axios({ url: url, method: "POST", data })
      .then(function (res) {
        unFreezeUI();
        if (res.data.status && res.data.updAddr) {
          $(ele).attr("data-addr-id", res.data.updAddr.ward);
          addrPostUpd(res.data);
          $("#modal_EditAddress").modal("hide");
        } else {
          $("div.error-account-upd").html(res.data.errorMsg);
        }
      })
      .catch(function (err) {
        console.log(err);
      });
  }
}

function notificationSeen(notifyId, ele) {
  let url = `${rootUrl}/customer/notificationSeen`;
  const data = { id : notifyId.split("-")[2]};
  axios({ url: url, method: "POST", data })
    .then(function (res) {
      if ($(data).hasClass("notification-list--unread")) {
        $(data).removeClass("notification-list--unread");
      }
      bindNotificationToUI(ele);
    })
    .catch(function (err) {
      console.log(err);
    });
}

function notificationReadmore(notifyId) {
  let notificationId = notifyId.split("-")[1];
  const contextData = "#context-" + notificationId;
  const myBtnData = "#myBtn-" + notificationId;
  if ($(myBtnData).hasClass("bi-chevron-down")) {
    $(myBtnData).removeClass("bi-chevron-down");
    $(myBtnData).addClass("bi-chevron-up");
    if ($(contextData).hasClass("context-truncate")) {
      $(contextData).removeClass("context-truncate");
    }
  } else if ($(myBtnData).hasClass("bi-chevron-up")) {
    $(myBtnData).removeClass("bi-chevron-up");
    $(myBtnData).addClass("bi-chevron-down");
    if (!$(contextData).hasClass("context-truncate")) {
      $(contextData).addClass("context-truncate");
    }
  }
}

function bindNotificationToUI(data) {
  if($("div.wex-mobile-basket div.notification-item-count").length){
    let url=`${rootUrl}/customer/getNumOfUnSeenNotification`;
    axios({url:url,method:"POST"}).then(function(res) {
      $("div.wex-mobile-basket div.notification-item-count").html(res.data.numOfUnSeenNotification);
    }).catch(function(err){
      console.log(err);
    });
  }
}

async function sendWelcomeVoucher(custId, referer) {
  let url = `${rootUrl}/customer/sendWelcomeVoucher`;
  const data = {custId: custId, referer: referer, notificationId: ["205", "210"]};
  axios({ url: url, method: "POST", data })
    .then(async function (res) {
      if (res.data.status) {
        console.log("Welcome Voucher sent");
      }
    })
    .catch(function (err) {
      console.log(err);
    });
}

export {
  bindCustomerEvents, bindNotificationToUI
};
